var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckThank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00008 30.0003C6.00008 16.8064 16.8062 6.00033 30.0001 6.00033C33.3526 6.00033 36.7042 6.7187 39.8159 8.15488C41.1531 8.77206 42.7375 8.18835 43.3546 6.85115C43.9718 5.51394 43.3881 3.92961 42.0509 3.31243C38.2293 1.54862 34.1142 0.666992 30.0001 0.666992C13.8607 0.666992 0.666748 13.8609 0.666748 30.0003C0.666748 46.1397 13.8607 59.3337 30.0001 59.3337C46.1395 59.3337 59.3334 46.1397 59.3334 30.0003V27.6003C59.3334 26.1276 58.1395 24.9337 56.6667 24.9337C55.194 24.9337 54.0001 26.1276 54.0001 27.6003V30.0003C54.0001 43.1942 43.194 54.0003 30.0001 54.0003C16.8062 54.0003 6.00008 43.1942 6.00008 30.0003Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5524 10.5526C59.5938 9.51121 59.5938 7.82277 58.5524 6.78137C57.511 5.73998 55.8225 5.73998 54.7811 6.78137L30.0001 31.5624L23.8857 25.448C22.8443 24.4066 21.1559 24.4066 20.1145 25.448C19.0731 26.4894 19.0731 28.1779 20.1145 29.2193L28.1145 37.2193C29.1559 38.2607 30.8443 38.2607 31.8857 37.2193L58.5524 10.5526Z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 30.4657,
    y1: -20.751,
    x2: 30.0001,
    y2: 59.3337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F165B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF503C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 30.4657,
    y1: -20.751,
    x2: 30.0001,
    y2: 59.3337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F165B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF503C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckThank);
export default __webpack_public_path__ + "static/media/check-thank.86bc06c9.svg";
export { ForwardRef as ReactComponent };